export default "__VITE_ASSET__CvpOYCG6__"